export default "__VITE_ASSET__1649d736__"